// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2euRF","errors":"Errors_errors__N7Q7w"};